import UIkit from './theme/UIKit';
import initAdvancedPlant from './theme/advancedPlant';
import initBentoBox from './theme/bentoBox';
import initContentArea from './theme/contentArea';
import initCropImages from './theme/cropImages';
import initCropRegion from './theme/cropRegion';
import initPerformanceMap from './theme/performanceMap';
import initFieldStudyPage from './theme/fieldStudyPage';
import initColumnContentVideo from './theme/columnContentVideo';
import initDealerLocatorModule from './theme/dealerLocatorModule';
import initJumpToNavigation from './theme/jumpToNavigation';
import initMainNavigation from './theme/mainNavigation';
import initnutrientKnowledge from './theme/nutrientKnowledge';
import initNutrientSelect from './theme/nutrientSelect';
import initNutrientTable from './theme/nutrientTable';
import initProductCards from './theme/productCards';
import initSlider from './theme/slider';
import initAgrifactFilterModule from './theme/agrifactFilterModule';
import initDropdowns from './theme/components/dropdown';
import initSuperLinks from './theme/superLinks';
import initSuperBack from './theme/superBack';
import initResourceBack from './theme/resourceBack';
import initRelatedPerformanceProducts from './theme/related-performance-products';
import initRvcForm from './theme/components/rvc_form';
import initSplitBannerRegionCrop from './theme/splitBannerRegionCrop';
import initDynamicRegionCropSection from './theme/dynamicRegionCropSection';
import initVideoBackground from './theme/videoBackground';
import initGatedContent from './theme/gatedContent';
import initResourceLibrary from './theme/resourceLibrary';
import initSplitBanner from './theme/splitBanner';
import initAnchorLink from './theme/anchorLink';
import initNutrientDeficiencies from './theme/nutrientDeficiencies';
import initSiteSearch from './theme/siteSearch';
import initPathFactory from './theme/pathfactory';
import initScoring from "./theme/scoring.js";
import initVimeo from './theme/vimeo.js';
import initSplitBannerModule from "./theme/components/split-banner.js";
import initVideoSlider from './theme/SliderVideo';

// Scripts

// AnchorLink needs to load first so that it
// can listen for events in other components
initAnchorLink();

initVimeo();
initAdvancedPlant();
initBentoBox();
initContentArea();
initCropImages();
initCropRegion();
initColumnContentVideo();
// initDealerLocatorModule();
initJumpToNavigation();
initMainNavigation();
initnutrientKnowledge();
initNutrientDeficiencies();
initNutrientSelect();
initNutrientTable();
initProductCards();
initSlider();
initAgrifactFilterModule();
initSuperLinks();
initSuperBack();
initResourceBack();
initRelatedPerformanceProducts();
initRvcForm();
initSplitBannerRegionCrop();
initDynamicRegionCropSection();
initVideoBackground();
initGatedContent();
initResourceLibrary();
initSplitBanner();
initSiteSearch();
initJumpToNavigation();
initPathFactory();
initScoring();
initPerformanceMap();
initFieldStudyPage();
initSplitBannerModule();
initVideoSlider();
// Needs to load last to setup events for other modules
initDropdowns();
